import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { TranslateModule } from "@ngx-translate/core";
import { UserHelpModesService } from "app/core/services/user-help-modes.service";
import { WhiteLabelService } from "app/core/white-label/white-label.service";
import { LogoutButtonComponent } from "app/shared/components/logout-button/logout-button.component";
import { SvgComponent } from "app/shared/components/svg/svg-icon/svg-icon.component";
import { UserInfoComponent } from "app/shared/components/user-info/user-info.component";
import { VerticalDividerComponent } from "app/shared/components/vertical-divider/vertical-divider.component";
import { environment } from "environments/environment";
import { Observable, tap } from "rxjs";

@Component({
  selector: "user-settings-drawer-details",
  templateUrl: "./user-settings-drawer-details.component.html",
  styleUrls: ["./user-settings-drawer-details.component.scss"],
  imports: [
    UserInfoComponent,
    VerticalDividerComponent,
    LogoutButtonComponent,
    SvgComponent,
    TranslateModule,
    MatSlideToggleModule,
    CommonModule,
  ],
})
export class UserSettingsDrawerDetailsComponent {
  @Output() public closeUserSettingsDrawer: EventEmitter<void> =
    new EventEmitter<void>();
  private readonly testUserProfileAppLink = "https://id-test.cloudya.com";
  private readonly testUserManagementAppLink = "https://accounts-test.nfon.com";
  public isHelpModeActive$: Observable<boolean> =
    this.userHelpModesService.isHelpModeActive$;

  constructor(
    private readonly whiteLabelService: WhiteLabelService,
    private userHelpModesService: UserHelpModesService,
  ) {}

  public openUserProfileApplication(): void {
    if (!!environment.production) {
      window.open(this.whiteLabelService.data.userProfileLink, "_blank");
    } else {
      window.open(this.testUserProfileAppLink, "_blank");
    }
  }

  public openUserManagement(): void {
    if (!!environment.production) {
      window.open(this.whiteLabelService.data.userManagementLink, "_blank");
    } else {
      window.open(this.testUserManagementAppLink, "_blank");
    }
  }

  public toggleHelpMode(isHelpModeActive: boolean): void {
    this.userHelpModesService.setHelpMode(isHelpModeActive);
  }
}
